import React from 'react';
import { Menu } from 'lucide-react';
import { useMobileHeader } from '../App/context/MobileHeaderContext';

const VIEW_TITLES = {
  'dashboard': 'Dashboard',
  'customers': 'Customer List',
  'customer-details': 'Customer Details',
  'jobs': 'Jobs',
  'job-details': 'Job Details',
  'invoices': 'Invoices',
  'emails': 'Sent Emails',
  'appointments': 'Appointments',
  'calendar': 'Calendar',
  'treatment-reports': 'Treatment Reports',
  'treatment-report-details': 'Report Details',
  'settings': 'Settings',
  'users': 'Users',
};

const MobileHeader = ({ onMenuClick, currentView, subtitle }) => {
  const { actions, subtitleExtra } = useMobileHeader();
  const title = VIEW_TITLES[currentView] || null;

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-sm z-30 md:hidden">
      <div className="flex items-center px-4 py-3">
        <button
          onClick={onMenuClick}
          className="p-2 rounded-lg hover:bg-gray-100 transition-colors flex-shrink-0"
          aria-label="Open menu"
        >
          <Menu size={24} className="text-gray-700" />
        </button>
        {title ? (
          <div className="ml-2 flex-shrink min-w-0">
            <h1 className="text-lg font-bold text-gray-900">{title}</h1>
            {subtitle && <p className="text-sm text-gray-500 truncate">{subtitle}</p>}
            {subtitleExtra && <p className="text-[10px] font-mono text-gray-400 truncate">{subtitleExtra}</p>}
          </div>
        ) : (
          <img
            src="/logo.png"
            alt="Pest Control"
            className="h-8 w-auto ml-3"
          />
        )}
        {actions && (
          <div className="ml-auto flex items-center gap-2">
            {actions}
          </div>
        )}
      </div>
    </header>
  );
};

export default MobileHeader;
